// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_5MV","cls2":"ExportFormatModal-cls2_WqX ExportFormatModal-cls1_5MV","isSelected":"ExportFormatModal-isSelected_QoW"};